<template>
  <div class="mb-0">
    <label class="switch">
      <input
          type="checkbox"
          :value="checked"
          :disabled="disabled"
          @change="$emit('update:checked', $event.target.checked)"
      />
      <span class="switcher mr-1"></span>
      <span class="text-black mr-1 ml-2 fs-md">{{ 'Показать номера блоками' + (checked ? " по" : '') }}</span>
    </label>
    <template v-if="checked">
      <input
          class="md"
          id="grouping-1"
          type="radio"
          value="3"
          :checked="value === 3"
          :disabled="groupingDisabled"
          @change="$emit('update:value', 3)"
      />
      <label for="grouping-1" class="mr-2">3</label>
      <input
          class="md"
          id="grouping-2"
          type="radio"
          value="5"
          :checked="value === 5"
          :disabled="groupingDisabled"
          @change="$emit('update:value', 5)"
      />
      <label for="grouping-2" class="mr-2">5</label>
    </template>
  </div>
</template>

<script>
export default {
  name: 'NumbersGroupingToggle',
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    groupingDisabled() {
      return !this.checked || this.disabled;
    },
  },
};
</script>

<style scoped>

</style>